import { render, staticRenderFns } from "./LmNewOrEdit.vue?vue&type=template&id=464c1e6c&"
import script from "./LmNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports